<mat-dialog-content class="modal-header">
  <h2 mat-dialog-title>PERSONAS - AUTORIZACION ACCESOS</h2>
</mat-dialog-content>


<mat-dialog-content class="modal-body">
  <div class="block-content">
    <div class="table-responsive">
      <table mat-table [dataSource]="modelListaSolicitudes" class="table table-striped table-vcenter">
        <ng-container matColumnDef="trabajador">
          <th mat-header-cell *matHeaderCellDef>Trabajador</th>
          <td mat-cell *matCellDef="let element">
            {{ element.nombres }} {{ element.apellidoPaterno }}
            {{ element.apellidoMaterno }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nroDocumentoIdentidad">
          <th mat-header-cell *matHeaderCellDef># Documento Identidad</th>
          <td mat-cell *matCellDef="let element">
            {{ element.nroDocumentoIdentidad }}
          </td>
        </ng-container>
        <ng-container matColumnDef="fechaInduccion">
          <th mat-header-cell *matHeaderCellDef>Fecha y hora de Inducción</th>
          <td mat-cell *matCellDef="let element" class="centre">
            {{ element.fechaInduccion | date: "dd/MM/yyyy" }}
          </td>
        </ng-container>    
        <ng-container matColumnDef="aprobado">
          <th mat-header-cell *matHeaderCellDef>Autorizado
            <mat-slide-toggle [(ngModel)]="checkTodosAutorizados" (change)="changeAutorizadoAll($event)">
            </mat-slide-toggle>
          </th>
          <td mat-cell *matCellDef="let element" class="centre">
            <mat-slide-toggle [(ngModel)]="element.autorizado" (change)="changeAutorizado(element)">
            </mat-slide-toggle>
          </td>
        </ng-container>

        <ng-container matColumnDef="desaprobado">
          <th mat-header-cell *matHeaderCellDef>No Autorizado
            <mat-slide-toggle [(ngModel)]="checkTodosRechazados" class="observado"
              (change)="changeRechazadoAll($event)">
            </mat-slide-toggle>

          </th>
          <td mat-cell *matCellDef="let element" class="centre">
            <mat-slide-toggle [(ngModel)]="element.rechazado" class="observado" (change)="changeRechazado(element)">
            </mat-slide-toggle>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button class="btn btn-naranja" mat-raised-button (click)="registrarResultados()" [disabled]="esInvalido()">
    <mat-icon>send</mat-icon> Enviar
  </button>
  <button
    type="button"
    class="btn btn-naranja2"
    mat-button
    (click)="onNoClick()"
  >
    <mat-icon>exit_to_app</mat-icon> Cancelar
  </button>
</mat-dialog-actions>